var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserAlt = function SvgUserAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C19.7266 18 22.75 14.9766 22.75 11.25C22.75 7.52344 19.7266 4.5 16 4.5C12.2734 4.5 9.25 7.52344 9.25 11.25C9.25 14.9766 12.2734 18 16 18ZM22 19.5H19.4172C18.3766 19.9781 17.2188 20.25 16 20.25C14.7812 20.25 13.6281 19.9781 12.5828 19.5H10C6.68594 19.5 4 22.1859 4 25.5V26.25C4 27.4922 5.00781 28.5 6.25 28.5H25.75C26.9922 28.5 28 27.4922 28 26.25V25.5C28 22.1859 25.3141 19.5 22 19.5Z",
    fill: "#009CA6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-alt.bfc77fdd.svg";
export { ForwardRef as ReactComponent };